import PlayerBar from './PlayerBar'

export default PlayerBar
